import Storage from 'utils/storage';
import Config from 'utils/config';

/*
 * Used to store items for performance (things that do not change such as types, statuses)
 * TEMPORARY: Kept for lifetime of page, cleared when page is refreshed or when user logs out
 * PERSISTANT: Kept for lieftime of session, cleared only when user logs out [Uses Storage API]
 */

const DEBUG = false;

let currentData = null;

function loadCache() {
  try {
    currentData = {
      persistant: Storage.getCompressedData('cache') || {},
      temporary: {},
    };
  }
  catch {
    currentData = {
      persistant: {},
      temporary: {},
    };
  }
}

function clear() {
  Storage.remove('cache');
  currentData = null;
}

function debugTemporary() {
  if (Config.debug === true && DEBUG === true) {
    console.log('Temporary cache altered:');
    console.log(currentData.temporary);
  }
}

function debugPersistant() {
  if (Config.debug === true && DEBUG === true) {
    console.log('Persistant cache altered:');
    console.log(currentData.persistant);
  }
}

function getPersistant(key) {
  if (currentData == null)
    loadCache();
  if (currentData.persistant) {
    return currentData.persistant[key];
  }
  return null;
}

function setPersistant(key, value) {
  if (currentData == null)
    loadCache();
  currentData.persistant[key] = value;
  Storage.setCompressedData('cache', currentData.persistant);
  debugPersistant();
}

function getTemporary(key) {
  if (currentData == null)
    loadCache();
  if (currentData.temporary) {
    return currentData.temporary[key];
  }
  return null;
}

function setTemporary(key, value) {
  if (currentData == null)
    loadCache();
  currentData.temporary[key] = value;
  debugTemporary();
}

const Cache = {
  clear,
  getPersistant,
  setPersistant,
  getTemporary,
  setTemporary
};

export default Cache;